import { render, staticRenderFns } from "./WorkTextEditor.vue?vue&type=template&id=7a5f9060&scoped=true"
import script from "./WorkTextEditor.vue?vue&type=script&lang=js"
export * from "./WorkTextEditor.vue?vue&type=script&lang=js"
import style0 from "./WorkTextEditor.vue?vue&type=style&index=0&id=7a5f9060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f9060",
  null
  
)

export default component.exports